module.exports = __webpack_public_path__ + "static/img/ying.f971b3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ying.jpg
// module id = wNnn
// module chunks = 0